import { TextReveal } from './textReveal';
import { TextLinesReveal } from './textLinesReveal';
import gsap from 'gsap';

export class Details {
    constructor(el, closeDetailsCtrl) {
        this.DOM = {
            el: el,
            images: el.querySelectorAll('.panel > .panel__img'),
            title: el.querySelector('.details__content > .details__content-title'),
            texts: el.querySelectorAll('.details__content > .details__content-text'),
            rtf: el.querySelector('.details__content > .details__content-rtf'),
            link: el.querySelector('.details__content > .details__content-link'),
            closeDetailsCtrl: closeDetailsCtrl
        };
        this.textLinesR = new TextLinesReveal(this.DOM.texts);
        // TextReveal obj (this.DOM.title and this.DOM.link animation)
        let textRevealElts = [this.DOM.title, this.DOM.closeDetailsCtrl];
        if (this.DOM.rtf !== null) { // some articles do not have rtf style. Adding null breaks details constructor
            textRevealElts.push(this.DOM.rtf);
        }
        if (this.DOM.link !== null) { // some articles do not have a link. Adding null breaks details constructor
            textRevealElts.push(this.DOM.link);
        }
        this.textReveal = new TextReveal(textRevealElts);
    }
    open() {
        this.DOM.el.classList.add('details--open');
        document.body.classList.add('state-details');

        this.textLinesR.in();
        this.textReveal.in();
        
        gsap.killTweensOf(this.DOM.images);
        gsap.timeline({defaults: {duration: 2, ease: 'expo'}})
        .set(this.DOM.images, {
            opacity: 0,
            y: '150%'
        })
        .to(this.DOM.images, {
            opacity: 1,
            y: '0%',
            stagger: 0.02
        });
    }
    close() {
        this.textLinesR.out();
        this.textReveal.out();
        
        gsap.killTweensOf(this.DOM.images);
        gsap.timeline({
            defaults: {duration: 0.5, ease: 'power2'},
            onComplete: () => {
                this.DOM.el.classList.remove('details--open');
                document.body.classList.remove('state-details');
            }
        })
        .to(this.DOM.images, {
            opacity: 0,
            y: '-150%',
            stagger: 0.01
        });
    }
    closeForInnerTransition() {
        this.textLinesR.out();
        this.textReveal.out();
        
        gsap.killTweensOf(this.DOM.images);
        gsap.timeline({
            defaults: {duration: 0.15, ease: 'power2'},
            onComplete: () => {
                this.DOM.el.classList.remove('details--open');
                document.body.classList.remove('state-details');
            }
        })
        .to(this.DOM.images, {
            opacity: 0,
            y: '-150%',
            stagger: 0.01
        });
    }
}